import { observer } from 'mobx-react-lite'
import React, { useContext, useState } from 'react'
import { CampaignContext } from '../../../../../contexts/CampaignContext'
import InfluencerItem from './Influencers/InfluencerItem'
import { isInfluencerVisibleInBudgetScenario } from './influencerBudgetVisibility'

export default observer(function Influencers({ campaignScenario }) {
  const [showHiddenInfluencers, setShowHiddenInfluencers] = useState(false)
  const { influencers, campaign, authentications } = useContext(CampaignContext)

  const influencerVisibilityMap = new Map()

  influencers.forEach(influencer => {
    influencerVisibilityMap.set(
      influencer.id,
      isInfluencerVisibleInBudgetScenario(campaignScenario, influencer, campaign, authentications)
    )
  })
  
  const showInfluencers = influencers.filter(influencer => influencerVisibilityMap.get(influencer.id))
  const hiddenInfluencers = influencers.filter(influencer => !influencerVisibilityMap.get(influencer.id))

  return (
    <div className='pb-4'>
      {showInfluencers.map(influencer => <InfluencerItem key={influencer.id} influencer={influencer} campaignScenario={campaignScenario} />)}
      <div className="py-4 relative my-4">
        <div className='border-t border-rb-green w-full' />
        <button 
          className='absolute left-1/2 transform -translate-x-1/2 -translate-y-1/2 px-2 py-1 border-1 border-rb-green text-rb-green dark:text-rb-green rounded-md bg-white dark:bg-rb-dark-mode dark:border-rb-green' 
          onClick={() => setShowHiddenInfluencers(!showHiddenInfluencers)}
        >
          {showHiddenInfluencers ? 'Hide List' : 'Show Hidden List'}
        </button>
      </div>
      {!showHiddenInfluencers && <span className='text-sm text-gray-500 dark:text-gray-400'>{hiddenInfluencers.length} hidden influencers</span>}
      {showHiddenInfluencers && hiddenInfluencers.map(influencer => <InfluencerItem key={influencer.id} influencer={influencer} campaignScenario={campaignScenario} />)}
    </div>
  )
})